export const externalConfig = {
  externalapihost: process.env.REACT_APP_EXTERNALRESTAPI_HOST || process.env.NODE_HOST || 'enhancer.lbl.gov' ||'pavlopoulos-lab.org',
  //externalapiport: process.env.REACT_APP_EXTERNALRESTAPI_PORT || 3306,
  externalapiport: process.env.REACT_APP_EXTERNALRESTAPI_PORT || 80,
  curationapihost: process.env.REACT_APP_CURATION_RESTAPI_HOST || process.env.NODE_HOST || 'enhancer.lbl.gov' ||'pavlopoulos-lab.org',
  //curationapiport: process.env.REACT_APP_CURATION_RESTAPI_PORT || 3307
  curationapiport: process.env.REACT_APP_CURATION_RESTAPI_PORT || 80
};

export const apiUrl =  "https://" +
                        //`${externalConfig.externalapihost}:${externalConfig.externalapiport}/api`;
                        `${externalConfig.externalapihost}/vista_api`;

export const curationApiUrl =  'https://' +
//`${externalConfig.curationapihost}:${externalConfig.curationapiport}/api`;
`${externalConfig.curationapihost}/vista_api`;
